import { inject, injectable } from 'inversify';
import { Observable, PureComputed } from 'knockout';
import { TwoFactorAuthTypes } from '../../../components/security/twofactorauth/twofactorauthsetup';
import { wccModules } from '../../../enums/wccModules';
import { EffectsContainer } from '../../../mixins/withEffects';
import { TwoFactorAuthService } from '../../../services/twofactorauth';

@injectable()
export default class TwoFactorAuthPage {
    private twoFactorAuthService: TwoFactorAuthService;

    labels = labels;

    title: PureComputed<string>;
    twoFactorAuthOptions: Observable<TwoFactorAuthTypes>;
    twoFactorAuthChoice: Observable<TwoFactorAuthTypes | null>;
    requiresSetup = ko.pureComputed(() => this.ready() && (this.twoFactorAuthChoice() == null || this.twoFactorAuthChoice() == TwoFactorAuthTypes.None));
    
    isStaging: boolean;

    isCodeValidated: Observable<boolean>;
    redirectUrl: string;

    ready = ko.observable(false);

    constructor(
        @inject(wccModules.twoFactorAuthService) twoFactorAuthService: TwoFactorAuthService,
        @inject(wccModules.effects) private effects: EffectsContainer
    ) {
        this.twoFactorAuthService = twoFactorAuthService;

        let authOptions: TwoFactorAuthTypes = WCC.getSetting('twoFactorAuthOptions') | TwoFactorAuthTypes.None;        
        this.twoFactorAuthOptions = ko.observable<TwoFactorAuthTypes>(authOptions);
        
        this.isStaging = settings.isStaging;

        this.title = ko.pureComputed(() => settings.isCommunity() ? labels.MFA_ParticipantTitle : labels.MFA_ParticipantTitlePasswordLess);

        //console.log(`twofactorauth container: ${WCC.getSetting('twoFactorAuthChoice')}`);

        this.twoFactorAuthChoice = ko.observable<TwoFactorAuthTypes>(WCC.getSetting('twoFactorAuthChoice') ?? null);

        //console.log(`twofactorauth container - authchoice: ${this.twoFactorAuthChoice()}`);

        this.isCodeValidated = ko.observable<boolean>(false);
        // redirect to redirectURL
        this.redirectUrl = WCC.getSetting('redirectUrl');
        this.isCodeValidated.subscribe((verified: boolean) => {
            if (verified) {
                //console.log(this.redirectUrl);
                settings.currentUser.IsTwoFactorAuthVerified = true;
                
                window.location.replace(this.redirectUrl != null ? this.redirectUrl : '/');
            }
        });

        this.init().then(result => {

            if (!result.Is2faRequired || (result.Is2faRequired && result.Is2faAuthenticated)) {
                window.location.href = this.redirectUrl ?? '/';
            }
            else {
                this.ready(true);
            }            
        });
    }

    async init() {
        //console.log('TwoFactorAuthPage init');

        return await this.twoFactorAuthService.isTwoFactorAuthenticated(settings.discussionId);
    }

    getView() {
        return require('views/twoFactorAuth.html');
    }

    activate() {
        const $container = $('body > .mainContainer');

        this.effects.register(() => {
            $container.css({ 'background-color': '#f3f3f3' });

            return () => $container.css({ 'background-color': '' });
        });
    }

}